/**
 * SUBSCRIPTION SELECTOR - Estilo LMNT
 * Versión con integración Treli para suscripciones
 *
 * Comportamiento:
 *   - Compra única:   muestra ATC + payment button (Shopify nativo)
 *   - Suscripción:    oculta ATC + payment button; muestra botón Treli si hay
 *                     link configurado para la variante + periodicidad actuales.
 *                     Si no hay link → oculta todos los botones de compra.
 *
 * Depende de:
 *   - window.TreliLinks  (cargado por assets/treli-links.js en productos Focus Booster)
 *   - Evento 'variant-change' (disparado por focus-variant-picker.js)
 */

(function () {
  'use strict';

  // ─── Estado ─────────────────────────────────────────────────────────────────
  var cache = {
    selector: null,
    purchaseRadios: null,
    frequencySelector: null,
    onetimePrice: null,
    subscriptionPrice: null
  };

  var currentVariantId    = null;   // string — ID de la variante activa
  var currentFrequency    = '30';   // string — valor del <select name="frequency">
  var currentPurchaseType = 'onetime';
  var variantAvailability = {};     // { "variantId": true/false } — BIOBOOSTERS

  // ─── Utilidad RAF ───────────────────────────────────────────────────────────
  var raf = function (callback) {
    return window.requestAnimationFrame
      ? window.requestAnimationFrame(callback)
      : setTimeout(callback, 16);
  };

  // ─── Inicialización ─────────────────────────────────────────────────────────
  function init() {
    cache.selector = document.querySelector('[data-subscription-selector]');

    if (!cache.selector) {
      return;
    }

    cache.purchaseRadios    = cache.selector.querySelectorAll('input[name="purchase-type"]');
    cache.onetimePrice      = cache.selector.querySelector('[data-onetime-price]');
    cache.subscriptionPrice = cache.selector.querySelector('[data-subscription-price]');
    cache.frequencySelector = cache.selector.querySelector('[name="frequency"]');

    // Leer el variant ID inicial desde el form (valor pre-seleccionado server-side)
    initVariantId();

    // BIOBOOSTERS: cargar disponibilidad de variantes (para ocultar suscripción si agotado)
    initVariantAvailability();

    // Leer la frecuencia inicial desde el select
    if (cache.frequencySelector) {
      currentFrequency = cache.frequencySelector.value;
    }

    // Leer el tipo de compra inicial
    var checkedRadio = cache.selector.querySelector('input[name="purchase-type"]:checked');
    if (checkedRadio) {
      currentPurchaseType = checkedRadio.value;
    }

    setupEventListeners();

    // BIOBOOSTERS: tooltip "¿Qué es una suscripción?" (tap en móvil)
    initInfoTooltips();

    // BIOBOOSTERS: botón secundario «Compra única · $X + envío»
    initCompraUnica();

    // BIOBOOSTERS: si la suscripción viene pre-seleccionada pero no es viable
    // (variante agotada o sin plan Treli), revertir a "Compra única".
    ensureViablePurchaseType();

    // BIOBOOSTERS: ocultar el bloque de suscripción si la variante no tiene plan
    updateSubscriptionAvailability();

    // Aplicar estado visual inicial
    updatePurchaseType(currentPurchaseType);

    // Reintentos: el picker de variantes y el catálogo de Treli pueden
    // terminar de montarse después de esta pasada.
    [0, 250, 800].forEach(function (ms) { setTimeout(revisar, ms); });
    window.addEventListener('load', revisar);
  }

  // === BIOBOOSTERS CUSTOM ===
  // Sin catálogo de Treli no se puede decidir nada: "todavía no cargó" no es
  // lo mismo que "esta variante no tiene plan". Confundirlos dejaba la
  // suscripción oculta y "Compra única" marcada hasta que el cliente cambiaba
  // de sabor, que era justo cuando volvía a correr esta lógica.
  function catalogoTreli() {
    var c = window.TreliLinks;
    return c && typeof c === 'object' && Object.keys(c).length ? c : null;
  }

  // Reintenta mientras el catálogo no esté, por si el script llega después
  // (orden de carga no garantizado cuando la sección se inyecta por JS).
  var esperas = 0;
  function esperarCatalogo() {
    if (esperas >= 40) return;   // ~4 s y se rinde
    esperas++;
    setTimeout(function () {
      if (!catalogoTreli()) { esperarCatalogo(); return; }
      ensureViablePurchaseType();
      revisar();
      updatePurchaseType(currentPurchaseType);
    }, 100);
  }

  var usuarioEligio = false;

  /* La suscripción es la opción por defecto de la ficha. Si alguna pasada
     temprana la escondió y marcó "Compra única" —pasa cuando el catálogo de
     Treli todavía no está—, la persona se queda sin verla hasta que cambia de
     sabor, que es cuando esta lógica vuelve a correr. Esto la devuelve sola,
     sin esperar a que el cliente toque nada, y solo mientras él no haya
     elegido: si eligió compra única, se respeta. */
  function restaurarSuscripcion() {
    if (usuarioEligio || !cache.selector) return;
    var catalogo = catalogoTreli();
    if (!catalogo) return;
    var cfg = catalogo[currentVariantId];
    if (!(isCurrentVariantAvailable() && cfg && cfg[currentFrequency])) return;

    var radio = cache.selector.querySelector('input[value="subscription"]');
    if (!radio || radio.checked) return;
    console.log('[Treli] suscripción restaurada para variant_id =', currentVariantId);
    radio.checked = true;
    currentPurchaseType = 'subscription';
    updatePurchaseType('subscription');
  }

  function revisar() {
    updateSubscriptionAvailability();
    restaurarSuscripcion();
  }

  function ensureViablePurchaseType() {
    if (currentPurchaseType !== 'subscription') return;
    var catalogo = catalogoTreli();
    if (!catalogo) return;   // no degradar a compra única por falta de datos
    var cfg = catalogo[currentVariantId];
    var viable = isCurrentVariantAvailable() && cfg && cfg[currentFrequency];
    if (!viable) {
      var oneRadio = cache.selector.querySelector('input[value="onetime"]');
      if (oneRadio) {
        oneRadio.checked = true;
        currentPurchaseType = 'onetime';
      }
    }
  }

  // === BIOBOOSTERS CUSTOM ===
  // Oculta TODO el bloque "Suscríbete y ahorra" si la variante activa no tiene
  // ningún plan de Treli (ej. Balance Pack con shaker: el shaker es compra única).
  // Debe correr en cada cambio de variante, no solo al iniciar.
  function updateSubscriptionAvailability() {
    if (!cache.selector) return;
    var option = cache.selector.querySelector('.subscription-option');
    if (!option) return;

    var catalogo = catalogoTreli();
    if (!catalogo) { esperarCatalogo(); return; }   // aún no se sabe: no ocultar

    var cfg = catalogo[currentVariantId];
    var hasAnyPlan = !!(cfg && (cfg['30'] || cfg['60'] || cfg['90']));

    if (hasAnyPlan) {
      option.style.removeProperty('display');
      return;
    }

    // Sin plan para esta variante: ocultar la opción y forzar compra única.
    option.style.setProperty('display', 'none', 'important');
    if (currentPurchaseType === 'subscription') {
      var oneRadio = cache.selector.querySelector('input[value="onetime"]');
      if (oneRadio) {
        oneRadio.checked = true;
        currentPurchaseType = 'onetime';
        updatePurchaseType('onetime');
      }
    }
  }

  // === BIOBOOSTERS CUSTOM: toggle del tooltip de info al tocar (el hover lo maneja el CSS) ===
  function initInfoTooltips() {
    document.querySelectorAll('.sub-info__btn').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();   // no seleccionar el radio de suscripción
        e.stopPropagation();  // no disparar el cierre "click afuera"
        var wrap = btn.closest('.sub-info');
        if (!wrap) return;
        var open = wrap.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
    // Cerrar al tocar fuera
    document.addEventListener('click', function (e) {
      if (e.target.closest('.sub-info')) return;
      document.querySelectorAll('.sub-info.is-open').forEach(function (w) {
        w.classList.remove('is-open');
        var b = w.querySelector('.sub-info__btn');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    });
  }

  // === BIOBOOSTERS CUSTOM: solo cuentan los formularios del producto de la página. Las
  // sugerencias de la cesta y los quick-buy también traen input[name="id"]; si se tomaba
  // uno de esos (p. ej. MNRL sugerido en la cesta), el botón de Treli se ocultaba. ===
  function esDeOtroProducto(el) {
    return !!(el && el.closest && el.closest('cart-drawer, quick-buy-modal, .complementary-products, product-card, .product-card'));
  }

  function initVariantId() {
    // Intentar varios selectores para encontrar el input del variant ID.
    // El input puede estar disabled (Prestige lo deshabilita cuando hay variant-picker block),
    // pero .value sigue siendo accesible aunque esté disabled.
    var selectors = [
      'product-form form input[name="id"]',
      'form[id*="product-form"] input[name="id"]',
      'form input[name="id"]'
    ];

    for (var i = 0; i < selectors.length; i++) {
      var candidatos = document.querySelectorAll(selectors[i]);
      var idInput = null;
      for (var j = 0; j < candidatos.length; j++) {
        if (candidatos[j].value && !esDeOtroProducto(candidatos[j])) { idInput = candidatos[j]; break; }
      }
      if (idInput && idInput.value) {
        currentVariantId = idInput.value.toString();
        console.log('[Treli] initVariantId: variant_id =', currentVariantId, '(selector: "' + selectors[i] + '")');
        return;
      }
    }

    console.warn('[Treli] initVariantId: no se encontró input[name="id"] con valor.');
  }

  // === BIOBOOSTERS CUSTOM: disponibilidad por variante (para ocultar la suscripción
  // cuando la variante está agotada). El mapa lo provee subscription-selector.liquid ===
  function initVariantAvailability() {
    var el = document.querySelector('[data-subscription-availability]');
    if (!el) return;
    try { variantAvailability = JSON.parse(el.textContent); }
    catch (e) { variantAvailability = {}; }
  }

  function isCurrentVariantAvailable() {
    // Sin dato → asumir disponible (no ocultar por falta de información)
    return variantAvailability[currentVariantId] !== false;
  }

  // ─── Event listeners ────────────────────────────────────────────────────────
  function setupEventListeners() {

    // Cambio de tipo de compra (onetime / subscription)
    cache.selector.addEventListener('change', function (e) {
      if (e.target.type === 'radio' && e.target.name === 'purchase-type') {
        usuarioEligio = true;   // a partir de acá nadie le cambia la elección
        currentPurchaseType = e.target.value;
        console.log('[Treli] purchase-type →', currentPurchaseType);
        raf(function () { updatePurchaseType(currentPurchaseType); });
      }
    }, { passive: true });

    // Cambio de periodicidad
    if (cache.frequencySelector) {
      cache.frequencySelector.addEventListener('change', function (e) {
        currentFrequency = e.target.value;
        console.log('[Treli] frecuencia →', currentFrequency);
        raf(function () { updateTreliButton(); });
      }, { passive: true });
    }

    // Cambio de variante (evento disparado por focus-variant-picker.js)
    document.addEventListener('variant-change', function (e) {
      if (esDeOtroProducto(e.target)) return;
      if (e.detail && e.detail.variant && e.detail.variant.id) {
        currentVariantId = e.detail.variant.id.toString();
        console.log('[Treli] variant-change → variant_id =', currentVariantId);
        raf(function () {
          updateSubscriptionAvailability();   // BIOBOOSTERS: mostrar/ocultar "Suscríbete y ahorra"
          updatePrices(e.detail.variant);
          updateTreliButton();
        });
      }
    });

    // Listener adicional: cambio directo en input[name="id"] (fallback para pickers custom)
    document.querySelectorAll('input[name="id"]').forEach(function (input) {
      if (esDeOtroProducto(input)) return;
      input.addEventListener('change', function () {
        if (this.value && this.value !== currentVariantId) {
          currentVariantId = this.value.toString();
          console.log('[Treli] input[name="id"] change → variant_id =', currentVariantId);
          raf(function () {
            updateSubscriptionAvailability();   // BIOBOOSTERS: mostrar/ocultar "Suscríbete y ahorra"
            if (currentPurchaseType === 'subscription') updateTreliButton();
          });
        }
      });
    });
  }

  // ─── Gestión del tipo de compra ─────────────────────────────────────────────
  function updatePurchaseType(type) {
    toggleAddToCart(type);
    toggleQuantitySelector(type);
    updateTreliButton();

    document.dispatchEvent(new CustomEvent('purchase-type-change', {
      detail: { type: type },
      bubbles: true
    }));
  }

  // ─── Botón ATC (Agregar al carrito) ─────────────────────────────────────────
  function toggleAddToCart(type) {
    var isSubscription = (type === 'subscription');

    var buyButtons = document.querySelector('buy-buttons');
    if (buyButtons) {
      var atcBtn = buyButtons.querySelector('[type="submit"]:not(.shopify-payment-button__button)');
      if (atcBtn) {
        atcBtn.style.display = isSubscription ? 'none' : '';
        return;
      }
    }

    var fallback = document.querySelector('.product-form__submit, button[name="add"]');
    if (fallback) {
      fallback.style.display = isSubscription ? 'none' : '';
    }
  }

  // ─── Selector de cantidad ────────────────────────────────────────────────────
  function toggleQuantitySelector(type) {
    var isSubscription = (type === 'subscription');
    var wrapper = document.querySelector('[data-quantity-selector-wrapper]');
    if (wrapper) {
      wrapper.style.display = isSubscription ? 'none' : '';
    }
  }

  // ─── Botón Treli ─────────────────────────────────────────────────────────
  /**
   * Muestra u oculta el botón Treli vs el payment button nativo de Shopify.
   * Usa classList (--hidden) para evitar conflictos con el CSS del tema.
   */
  // === BIOBOOSTERS CUSTOM: botón «Compra única · $X + envío» (solo con la suscripción elegida) ===
  function syncCompraUnica(isSubscription) {
    var mostrar = isSubscription && isCurrentVariantAvailable();
    document.querySelectorAll('[data-compra-unica]').forEach(function (el) {
      if (esDeOtroProducto(el)) return;
      el.hidden = !mostrar;
    });
  }

  function initCompraUnica() {
    document.querySelectorAll('button[data-compra-unica]').forEach(function (btn) {
      if (esDeOtroProducto(btn)) return;
      btn.addEventListener('click', function () {
        var once = cache.selector && cache.selector.querySelector('input[name="purchase-type"][value="onetime"]');
        if (once && !once.checked) {
          once.checked = true;
          once.dispatchEvent(new Event('change', { bubbles: true }));
        }
        // Espera a que el selector muestre «Añadir a la cesta» y lo usa: la cesta lateral se abre sola
        setTimeout(function () {
          var form = btn.closest('form') || document.querySelector('form[id*="product-form-main"]');
          var atc = (btn.closest('buy-buttons') || document).querySelector('[type="submit"]:not(.shopify-payment-button__button)');
          if (atc) atc.click();
          else if (form && form.requestSubmit) form.requestSubmit();
        }, 80);
      });
    });
  }

  function updateTreliButton() {
    var treliBtn    = document.querySelector('[data-treli-button]');
    var paymentWrap = document.querySelector('.shopify-payment-button');

    var isSubscription = (currentPurchaseType === 'subscription');

    syncCompraUnica(isSubscription);
    console.log('[Treli] updateTreliButton | suscripción:', isSubscription, '| treliBtn:', !!treliBtn, '| paymentWrap:', !!paymentWrap);

    if (!isSubscription) {
      showPaymentButton(paymentWrap);
      hideBtn(treliBtn);
      return;
    }

    // BIOBOOSTERS CUSTOM: si la variante está agotada, no ofrecer suscripción
    if (!isCurrentVariantAvailable()) {
      console.log('[Treli] variante agotada → ocultar suscripción');
      hideBtn(treliBtn);
      hidePaymentButton(paymentWrap);
      return;
    }

    var url = getTreliUrl();
    console.log('[Treli] URL →', url);

    if (url) {
      treliBtn.href = url;
      showBtn(treliBtn);
      hidePaymentButton(paymentWrap);
    } else {
      hideBtn(treliBtn);
      hidePaymentButton(paymentWrap);
    }
  }

  // Helpers para mostrar/ocultar con classList (evita conflictos con CSS del tema)
  function showBtn(el) {
    if (!el) return;
    el.classList.remove('treli-subscribe-btn--hidden');
  }

  function hideBtn(el) {
    if (!el) return;
    el.classList.add('treli-subscribe-btn--hidden');
  }

  function hidePaymentButton(el) {
    if (!el) return;
    el.style.setProperty('display', 'none', 'important');
  }

  function showPaymentButton(el) {
    if (!el) return;
    el.style.removeProperty('display');
  }

  // ─── Lookup de URL Treli ─────────────────────────────────────────────────────
  function getTreliUrl() {
    if (!window.TreliLinks) {
      console.warn('[Treli] window.TreliLinks no definido — ¿está cargado treli-links.js?');
      return null;
    }

    if (!currentVariantId) {
      console.warn('[Treli] currentVariantId es null.');
      return null;
    }

    var variantConfig = window.TreliLinks[currentVariantId];

    if (!variantConfig) {
      console.warn('[Treli] Sin entrada para variant_id "' + currentVariantId + '" en TreliLinks.');
      console.log('[Treli] Claves disponibles:', Object.keys(window.TreliLinks));
      return null;
    }

    var url = variantConfig[currentFrequency];

    if (!url || url.trim() === '') {
      console.warn('[Treli] Sin URL para frecuencia "' + currentFrequency + '" en variant_id "' + currentVariantId + '".');
      return null;
    }

    return url;
  }

  // ─── Actualización de precios al cambiar variante ───────────────────────────
  function updatePrices(variant) {
    if (!variant || !variant.price) return;

    var onetimePrice      = variant.price;
    var subscriptionPrice = Math.round(variant.price * 0.85);

    if (cache.onetimePrice)      cache.onetimePrice.textContent = formatMoney(onetimePrice);
    document.querySelectorAll('[data-compra-unica-precio]').forEach(function (el) {   // BIOBOOSTERS
      if (!esDeOtroProducto(el)) el.textContent = formatMoney(onetimePrice);
    });
    if (cache.subscriptionPrice) cache.subscriptionPrice.textContent = formatMoney(subscriptionPrice);

    var onetimeRadio      = cache.selector.querySelector('input[value="onetime"]');
    var subscriptionRadio = cache.selector.querySelector('input[value="subscription"]');

    if (onetimeRadio)      onetimeRadio.setAttribute('data-price', onetimePrice);
    if (subscriptionRadio) subscriptionRadio.setAttribute('data-price', subscriptionPrice);
  }

  // ─── Formateo de moneda ──────────────────────────────────────────────────────
  function formatMoney(cents) {
    var amount    = (cents / 100).toFixed(2);
    var formatted = amount.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return '$' + formatted.replace('.00', '');
  }

  // ─── Bootstrap ──────────────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();